/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, Suspense } from 'react'
import { useTexture, Cylinder } from '@react-three/drei'
import * as THREE from "three";
import { PreviewDestinationOutlines } from "../../PreviewDestinationOutlines";


 
export function CurvedPanels({ showDestinationOutline, ...props }) { 

    const group = useRef()
    return (
      <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} onClick={(e) => {e.stopPropagation() 
        props.clickFunction()}}>
          <group rotation={[0, Math.PI,0]} position={[0,0.5,1.125]}>
          <Cylinder
          args={[1,1,1,30,1,true,-1.5,3]}          
          >
          <meshStandardMaterial
            side={THREE.DoubleSide}
            receiveShadow
            opacity={1}
            color={props.colour}
          />
          {showDestinationOutline && <PreviewDestinationOutlines />}
          </Cylinder>
          </group>
    </group>
    )
  }  
  

  export function CurvedPanelsTexture({ showDestinationOutline, ...props }) {
    const texture = useTexture(props.imageTexture)

      const group = useRef()
      return (
        <Suspense fallback={null}>
        <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} >
          <group rotation={[0,Math.PI,0]}  position={[0,props.height / 2,props.width]}>
             <Cylinder
          args={[props.width ? props.width : 1, props.width ? props.width : 1, props.height ? props.height : 1, 30, 1, true, props.curveAmount ? props.curveAmount/4 : -1, props.curveAmount ? -props.curveAmount/4 * 2 : -2]}                   
          >
          <meshStandardMaterial
            side={THREE.DoubleSide}
            receiveShadow
            opacity={1}
            color={props.colour}
            map={texture}
            transparent
          />
          {showDestinationOutline && <PreviewDestinationOutlines />}
          </Cylinder>
          </group>
      </group></Suspense>
      )
    } 
    
